import ThisWeek from './ThisWeek'

export default ThisWeek


// WEBPACK FOOTER //
// ./src/components/FrontPage/ThisWeek/index.js